
import { getMobileOS } from '@xanadu/ui-shared/utils/deviceDetection';

export default function getTerminal() {
  const platform = getMobileOS();
  if (platform === 'iOS') {
    return 'iPhone';
  }
  if (platform === 'Android') {
    return 'Android';
  }
  return 'PC';
}

